const Auth = {
    region: process.env.REACT_APP_AUTH_REGION,
    userPoolId: process.env.REACT_APP_AUTH_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_AUTH_USER_POOL_WEB_CLIENT_ID,
    storage:window.localStorage,
    authenticationFlowType: 'USER_SRP_AUTH',
    identityPoolId: process.env.REACT_APP_IDENTIFYPOOLID
  }

export default Auth